import React, { useState } from 'react';
import './Projects.css';
import AMZN from '../assets/images/projects/amazonclone.png';
import CONVERT from '../assets/images/projects/currencyconverter.png';
import TRACK from '../assets/images/projects/expensetracker.png';
import QTEXT from '../assets/images/projects/Qtext.png';
import MOVIE from '../assets/images/projects/movierecommedation.png';
import PORTFOLIO from '../assets/images/projects/portfolio.png';
import FINANCE from '../assets/images/projects/finance-tracker.png'
import DONEX from '../assets/images/projects/donex.png';
import BLOG from '../assets/images/projects/bloging.png';
import PREPVIEW from '../assets/images/projects/ai-interview.png';
import Section from './Section';
import { motion } from 'framer-motion';

const Projects = () => {
  const [activeCategory, setActiveCategory] = useState('ALL');

  const projects = [
    {
      title: 'AI Interview Platform',
      description: 'Python',
      category: 'AI/ML',
      image: PREPVIEW,
      link: 'https://prepview-ai.vercel.app/',
      github: 'https://github.com/Ankitsm04/Prep_view',
    },
    {
      title: 'Full Stack Blogging  Website',
      description: 'Python',
      category: 'AI/ML',
      image: BLOG,
      link: 'https://full-stack-blogging-app-five.vercel.app/',
      github: 'https://github.com/Ankitsm04/Full-stack-Blogging-App',
    },
    {
      title: 'Movie Recommendation System',
      description: 'Python',
      category: 'AI/ML',
      image: MOVIE,
      link: 'https://ml-movie-recommendation-system.streamlit.app/',
      github: 'https://github.com/Ankitsm04/Movie-Recommendation-System',
    },
    {
      title: 'Currency Converter',
      description: 'HTML/CSS/JS',
      category: 'Web Dev',
      image: CONVERT,
      link: 'https://currency-convert-by-ankit.netlify.app/',
      github: '',
    },
    {
      title: 'Finance Tracker',
      description: 'Next.js/Redux',
      category: 'Web Dev',
      image: FINANCE,
      link: 'https://finance-tracker-ankit.vercel.app/',
      github: 'https://github.com/Ankitsm04/Personal-Finance-Tracker',
    },
    {
      title: 'Company Portfolio',
      description: 'HTML/CSS/JS',
      category: 'Web Dev',
      image: DONEX,
      link: 'https://donexinfotech.vercel.app/',
      github: '',
    },
    {
      title: 'Amazon Clone',
      description: 'HTML/CSS/JS',
      category: 'Web Dev',
      image: AMZN,
      link: 'https://amazon-clone-38.netlify.app/',
      github: 'https://github.com/Ankitsm04/Personal-Finance-Tracker',
    },
    {
      title: 'Expense Tracker',
      description: 'HTML/CSS/JS',
      category: 'Web Dev',
      image: TRACK,
      link: 'https://expensetrackerfromankit.netlify.app/',
      github: 'https://github.com/Ankitsm04/Personal-Finance-Tracker',
    },
    {
      title: 'Text Formatting App',
      description: 'React',
      category: 'Web Dev',
      image: QTEXT,
      link: 'https://qtext-react.vercel.app/',
      github: 'https://github.com/Ankitsm04/Personal-Finance-Tracker',
    },
    
  ];

  const handleCategoryClick = (category) => {
    setActiveCategory(category);
  };

  const filteredProjects = projects.filter(
    (project) => activeCategory === 'ALL' || project.category === activeCategory
  );

  return (
    <div className='projects' id='projects'>
      <Section id="head">
        <div className='head'>
          <p>Projects</p>
          <div className='line'></div>
        </div>
      </Section>
      <Section>
        <div className='projects-nav'>
          <ul>
            {['ALL', 'Web Dev', 'AI/ML'].map((category) => (
              <li
                key={category}
                className={activeCategory === category ? 'active' : ''}
                onClick={() => handleCategoryClick(category)}
              >
                {category}
              </li>
            ))}
          </ul>
        </div>
      </Section>
      <div className='projects-cards'>
        {filteredProjects.map((project, index) => (
          <Section key={index} id={`project-${index}`}>
            <div
              className={`project-card ${activeCategory === project.category || activeCategory === 'ALL' ? 'show' : ''}`}
              style={{ backgroundImage: `url(${project.image})` }}
            >
              <div className='overlay'>
                <h3>{project.title}</h3>
                <div className='buttons-container'>
                {
                  project.link && (
                <a href={project.link} class="menu__button">
                <span>Live Link</span>                 
                </a>
                  )
                }
                {
                  project.github && (
                <a href={project.github} class="menu__button">
                <span>Github</span>                 
                </a>
                  )
                }
                </div>
              </div>
            </div>
          </Section>
        ))}
      </div>
    </div>
  );
};

export default Projects;
